import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaForm from './VaForm.vue'

export default withConfigTransport(VaForm)
